<template>

    <div id="form-container" ref="formContainer">
        <b-container fluid>
            <h1>Claim My Licenses</h1>
            <b-row>
                <b-col>
                    <p>
                        Enter your Minnesota Body Art license number and social security number to claim your full technician
                        or temporary technician or guest license. Only enter the numbers as indicated on your printed license.
                        Do not enter any letters.
                    </p>
                    <p>
                        If you are a guest artist from outside the US, you will need to enter your Minnesota Body Art license number, your date of birth,
                        and your last name.
                    </p>
                </b-col>
            </b-row>

            <b-form class="mt-3">
                <b-row>
                    <b-col>
                        <BaseCheckboxInput v-model="international"
                                           :v="$v.international"
                                           label="I am a guest artist from outside the US"
                                           slug="international"
                                           setId="international"
                        />
                    </b-col>
                </b-row>
                <b-row v-if="!international">
                    <b-col cols="12" lg="6">
                    <BaseTextInput v-model="toClaim.licNbr"
                                   :v="$v.toClaim.licNbr"
                                   slug="licNbr"
                                   label="License Number"
                                   setId="licNbr"
                    />
                    </b-col>
                    <b-col cols="12" lg="6">
                    <BaseMaskedTextInput v-model="toClaim.ssn"
                                         :v="$v.toClaim.ssn"
                                         slug="ssn"
                                         label="Social Security Number"
                                         setId="ssn"
                                         mask="###-##-####"
                    />
                    </b-col>
                </b-row>
                <b-row v-if="international">
                    <b-col cols="12" lg="4">
                        <BaseTextInput v-model="toClaim.licNbr"
                                       :v="$v.toClaim.licNbr"
                                       slug="licNbr"
                                       label="License Number"
                                       setId="licNbr"
                        />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseDateOfBirthInput v-model="toClaim.dob"
                                              :v="$v.toClaim.dob"
                                              label="Date of Birth"
                                              slug="dob"
                                              setId="dob"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextInput v-model="toClaim.lastName"
                                       :v="$v.toClaim.lastName"
                                       slug="lastName"
                                       label="Last Name"
                                       setId="lastName"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-button type="button" variant="primary" @click="claimLicense">Claim License</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-container>

    </div>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import { required, requiredIf, minLength } from 'vuelidate/lib/validators'
import ssn from '@/validators/ssn'

export default {
    data() {
        return {
            toClaim: {
                ssn: null,
                licNbr: null,
                dob: null,
                lastName: null,
            },
            international: false
        }
    },
    validations() {
        return {
            toClaim: {
                ssn: {
                    required: requiredIf(function() { return !this.international }), minLength: minLength(11),
                },
                licNbr: {
                    required, minLength: minLength(5)
                },
                dob: {required: requiredIf(function() { return this.international })},
                lastName: {required: requiredIf(function() { return this.international })},
            },
            international: {required},
        }
    },
    methods: {
        claimLicense() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$nextTick(() => {
                    document.getElementById('form-container').scrollIntoView()
                })
                return
            }
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/license/claim`,
                this.toClaim)
                .then(response => {
                    if(response.status === 200) {
                        this.showRootToast("License Claimed", "You have claimed license "+this.toClaim.licNbr+" .", "success")
                        this.reset();
                    }
                })
                .catch(error => {
                    if (error.response.status === 409) {
                        this.showRootToast("License Not Claimed",
                            "The License you have attempted to claim does not exist or has already been claimed.  " +
                            "Please check that the license number and social security number are correct.", "danger")
                    } else if (error.response.status === 406) {
                        this.showRootToast("License Not Claimed", this.createExpiredLicenseToast(), "danger")
                    } else {
                        this.showRootToast("License Not Claimed", "An error has occurred while processing your request", "danger")
                    }
                })
        },
        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                title: title,
                toaster: 'b-toaster-top-center',
                solid: true,
                variant: type,
                appendToast: true,
                noAutoHide:true
            })
            this.toastFocus()
        },
        toastFocus() {
            setTimeout(() => {
                let elem = document.getElementsByClassName("toast")
                elem = elem[elem.length-1]
                elem.focus()
            }, 100)
        },
        reset() {
            this.toClaim.ssn = null
            this.toClaim.licNbr = null
            this.$v.$reset()
        },
        createExpiredLicenseToast() {
            const h = this.$createElement
            const nodes = h(
                'div',
                [
                    h('span','License has been expired more than 6 years.  Please contact '),
                    h('a', {attrs:{href: 'mailto:health.ba@state.mn.us'}}, 'health.ba@state.mn.us'),
                    h('span',' or call 651-201-3770 for assistance claiming this license.')
                ]
            )
            return nodes
        }
    },
    created() {
        document.title = "Claim License - Body Art"
    }
}
</script>